import { DeviceUiMutation, DeviceUiState } from './types'
import { MutationTree } from 'vuex'

export const mutations: MutationTree<DeviceUiState> = {
  [DeviceUiMutation.setLoading](state: DeviceUiState, loading: boolean) {
    state.loading = loading
  },
}
